import { Editor } from 'react-draft-wysiwyg'
import { Field } from 'formik'
import draftToHtml from 'draftjs-to-html'
import { convertToRaw } from 'draft-js'
import {
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  Button,
  Table,
  FormText,
} from 'reactstrap'
import CustomSelect from '../elements/CustomSelect'
import DatePicker from 'reactstrap-date-picker'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './visit-form.scss'
import { userRoles } from '../../mock-data/roles'

const VisitForm = ({
  userData,
  townships,
  members,
  formik,
  row,
  col,
  tableData,
  setRow,
  setCol,
  setTableData,
  onFileChange,
}) => {
  let townshipOptions = townships.map((element) => {
    return {
      value: element.id,
      label: element.name,
    }
  })

  let memberOptions = members.map((element) => {
    return {
      value: element.id,
      label: `${element.username} (${
        userRoles.find((role) => role.id == element.role)?.name
      })`,
    }
  })

  const onGenerateTable = () => {
    let datas = []
    if (row && col) {
      for (var i = 0; i < row; i++) {
        let rowData = []
        for (var c = 0; c < col; c++) {
          rowData.push('')
        }
        datas.push(rowData)
      }
    }
    setTableData(datas)
  }

  const onDeleteTable = () => {
    setTableData([])
  }

  const onAddRow = () => {
    alert('hi')
    tableData.push([])
    setTableData(tableData)
  }

  const onRemoveRow = (index) => {}

  return (
    <>
      <Row>
        <Col md={{ size: 4 }}>
          <FormGroup>
            <Label for="date">Date</Label>
            <Field
              name="date"
              component={DatePicker}
              value={formik.values.date}
              onChange={(value) => formik.setFieldValue('date', value)}
            />
            <span className="text-danger">
              {formik.errors.date && formik.touched.date && formik.errors.date}
            </span>
          </FormGroup>
        </Col>
        <Col md={{ size: 4 }}>
          <FormGroup>
            <Label for="townships">Townships</Label>
            <CustomSelect
              options={townshipOptions}
              multi={true}
              name="township_ids"
              value={formik.values.township_ids}
              onChange={(value) => {
                formik.setFieldValue('township_ids', value)
              }}
              value={formik.values.township_ids}
            />
            <span className="text-danger">
              {formik.errors.township_ids &&
                formik.touched.township_ids &&
                formik.errors.township_ids}
            </span>
          </FormGroup>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={{ size: 4 }}>
          <FormGroup>
            <Label for="coVisitors">Co Visitors</Label>
            <CustomSelect
              name="co_visitors"
              options={memberOptions}
              multi={true}
              onChange={(value) => formik.setFieldValue('co_visitors', value)}
              value={formik.values.co_visitors}
            />
            <span className="text-danger">
              {formik.errors.co_visitors &&
                formik.touched.co_visitors &&
                formik.errors.co_visitors}
            </span>
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label for="placeToVisit">Type Of Visit</Label>
            <CustomSelect
              options={[
                { value: 1, label: 'In Person' },
                { value: 2, label: 'Virtual' },
              ]}
              onChange={(value) =>
                formik.setFieldValue('type_of_visit', value.value)
              }
              value={formik.values.type_of_visit}
              name="type_of_visit"
            />
            <span className="text-danger">
              {formik.errors.type_of_visit &&
                formik.touched.type_of_visit &&
                formik.errors.type_of_visit}
            </span>
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label for="placeToVisit">Visit Place</Label>
            <Input
              type="text"
              name="place_of_visit"
              placeholder="type here..."
              onChange={formik.handleChange}
              value={formik.values.place_of_visit}
            />
            <span className="text-danger">
              {formik.errors.place_of_visit &&
                formik.touched.place_of_visit &&
                formik.errors.place_of_visit}
            </span>
          </FormGroup>
        </Col>
      </Row>
      {userData.role != 3 && userData.role != 4 && (
        <Row className="mt-4 editor-main">
          <Col md="6">
            <FormGroup>
              <label>Coordination</label>
              <Editor
                toolbarClassName="editor-toolbar"
                wrapperClassName="editor-wrapper"
                editorClassName="editor"
                toolbar={{ options: ['list'] }}
                name="coordination"
                defaultEditorState={formik.values.coordination}
                onEditorStateChange={(editorState) => {
                  const rawContentState = convertToRaw(
                    editorState.getCurrentContent()
                  )
                  const markup = draftToHtml(rawContentState)
                  formik.setFieldValue('coordination', markup)
                }}
                value={formik.values.coordination}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup>
              <label>Program</label>
              <Editor
                toolbarClassName="editor-toolbar"
                wrapperClassName="editor-wrapper"
                editorClassName="editor"
                toolbar={{ options: ['list'] }}
                name="program"
                defaultEditorState={formik.values.program}
                onEditorStateChange={(editorState) => {
                  const rawContentState = convertToRaw(
                    editorState.getCurrentContent()
                  )
                  const markup = draftToHtml(rawContentState)
                  formik.setFieldValue('program', markup)
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      )}
      {userData.role != 3 && userData.role != 4 && (
        <Row className="mt-4 editor-main">
          <Col md="6">
            <FormGroup>
              <label>M & E</label>
              <Editor
                toolbarClassName="editor-toolbar"
                wrapperClassName="editor-wrapper"
                editorClassName="editor"
                toolbar={{ options: ['list'] }}
                name="m_and_e"
                defaultEditorState={formik.values.m_and_e}
                onEditorStateChange={(editorState) => {
                  const rawContentState = convertToRaw(
                    editorState.getCurrentContent()
                  )
                  const markup = draftToHtml(rawContentState)
                  formik.setFieldValue('m_and_e', markup)
                }}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup>
              <label>Recommendation</label>
              <Editor
                toolbarClassName="editor-toolbar"
                wrapperClassName="editor-wrapper"
                editorClassName="editor"
                toolbar={{ options: ['list'] }}
                name="recommendation"
                defaultEditorState={formik.values.recommendation}
                onEditorStateChange={(editorState) => {
                  const rawContentState = convertToRaw(
                    editorState.getCurrentContent()
                  )
                  const markup = draftToHtml(rawContentState)
                  formik.setFieldValue('recommendation', markup)
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      )}

        <Row className="mt-4 ">
          <Col md="4">
            <FormGroup>
              <Label for="exampleFile">File</Label>
              <Input
                type="file"
                name="file"
                id="exampleFile"
                onChange={(e) => onFileChange(e.target.files[0])}
                accept=".xls,.xlsx,.pdf,.doc,.docx,.csv"
              />
              <br />
              <FormText color="muted">Upload attachment file.</FormText>
            </FormGroup>
          </Col>
        </Row>
      <Row className="mt-4">
        <Label for="placeToVisit">Information</Label>
        <div className="mt-4">
          <h6>Generate Tables</h6>
        </div>
        <Row className="mt-3">
          <Col md="3">
            <label>Row</label>
            <input
              type="number"
              className="form-control mt-2"
              onChange={(e) => setRow(e.target.value)}
            />
          </Col>
          <Col md="3">
            <label>Col</label>
            <input
              type="number"
              className="form-control mt-2"
              onChange={(e) => setCol(e.target.value)}
            />
          </Col>

          <Col md="3" style={{ paddingTop: '32px' }}>
            {tableData.length == 0 && (
              <Button onClick={onGenerateTable}>Generate</Button>
            )}
            {tableData.length > 0 && (
              <>
                <Button
                  style={{ marginLeft: 20 }}
                  onClick={onDeleteTable}
                  color="danger"
                >
                  Delete Table
                </Button>
              </>
            )}
          </Col>
        </Row>
      </Row>
      <Row className="mt-5">
        <Table style={{ width: '70%', marginLeft: '15%' }}>
          {tableData.map((e, rIndex) => (
            <tr>
              {e.map((b, cIndex) => (
                <td>
                  <input
                    type="text"
                    style={{ width: '100%' }}
                    defaultValue={tableData[rIndex][cIndex]}
                    onChange={(e) => {
                      tableData[rIndex][cIndex] = e.target.value
                      setTableData(tableData)
                    }}
                  />
                </td>
              ))}
              <td>
                <span onClick={() => onRemoveRow(rIndex)}>X</span>
              </td>
            </tr>
          ))}
        </Table>
      </Row>
    </>
  )
}

export default VisitForm
